/* Publish by EComposer at 2026-10-26 05:02:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8eol4xfwcq3"]=  window.__ectimmers["ecom-8eol4xfwcq3"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8eol4xfwcq3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8eol4xfwcq3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhb2ga3i75').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhb2ga3i75', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tg2ivfumsf8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tg2ivfumsf8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tjrvdievb2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tjrvdievb2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6kntsn8259n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6kntsn8259n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8xwsrz14qml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8xwsrz14qml', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9o85ebespd6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9o85ebespd6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ehsqn4g88va').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ehsqn4g88va', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0yq4et4g3b3j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0yq4et4g3b3j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6948h1aru6y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6948h1aru6y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eir1xpe9jw7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eir1xpe9jw7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wwmipgpx2gi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wwmipgpx2gi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7rcf0qn22j4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rcf0qn22j4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tgqf6gpxmxo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tgqf6gpxmxo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tiqw2cpnu3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tiqw2cpnu3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4aaoz9tlbg2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4aaoz9tlbg2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzckxw210ar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzckxw210ar', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3bu6msxz4ts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3bu6msxz4ts', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u0q2cn4vp1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u0q2cn4vp1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1jnec83ezqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1jnec83ezqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cbw45t0pdrf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cbw45t0pdrf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-575w8r2kzbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-575w8r2kzbg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-83z0rpqc22o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-83z0rpqc22o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e9uwoycm0ho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e9uwoycm0ho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8bb1jaiik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8bb1jaiik', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8nk9wp9x0xo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8nk9wp9x0xo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7dyjpo4stj6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7dyjpo4stj6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ejm31c4bkvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ejm31c4bkvg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhn89vpxv8u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhn89vpxv8u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ul8hkifiifm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ul8hkifiifm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vv0r09rrceq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vv0r09rrceq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9s1wx7xa2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9s1wx7xa2a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k38rw6hv5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k38rw6hv5g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qxj6nw99sok').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qxj6nw99sok', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qxzb7ivkmyb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qxzb7ivkmyb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zo5g6j829br').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zo5g6j829br', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xrxkyucmfi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xrxkyucmfi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5k3zibqsb1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5k3zibqsb1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vabszs6zdj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vabszs6zdj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xza08odoia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xza08odoia', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36n35qqp9sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36n35qqp9sc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2i8gm00cebv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2i8gm00cebv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ntlbaxpruq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ntlbaxpruq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1w2v014nh3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1w2v014nh3b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fypnzy0f1mh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fypnzy0f1mh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jm0z4qi38oj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jm0z4qi38oj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8ms7j3nztq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8ms7j3nztq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-08u9xiyps2gw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-08u9xiyps2gw', settings: {},isLive: true});
                        });
                    

                })();
            